module.exports = __webpack_public_path__ + "img/basket-filled-icon.973c2fe7.svg";